import { render, staticRenderFns } from "./ChatAudioPlayer.vue?vue&type=template&id=8ef4d14a&scoped=true&"
import script from "./ChatAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./ChatAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ChatAudioPlayer.vue?vue&type=style&index=0&id=8ef4d14a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef4d14a",
  null
  
)

export default component.exports